export function RunePattern3({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 680 680" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <title>Rune Pattern</title>
      <g opacity="0.4">
        <g filter="url(#filter0_f_525_13657)">
          <path
            d="M340.856 593.999C480.86 593.803 594.197 480.148 594 340.144C593.804 200.14 480.149 86.8033 340.145 86.9997C200.141 87.196 86.8046 200.851 87.001 340.855C87.1973 480.859 200.852 594.195 340.856 593.999Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M161.302 199.25C182.013 199.221 198.779 182.409 198.75 161.698C198.721 140.987 181.908 124.221 161.197 124.251C140.487 124.28 123.721 141.092 123.75 161.803C123.779 182.514 140.592 199.279 161.302 199.25Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M86.5534 378.355C107.264 378.326 124.03 361.514 124.001 340.803C123.972 320.092 107.159 303.327 86.4482 303.356C65.7375 303.385 48.9718 320.197 49.0008 340.908C49.0299 361.619 65.8427 378.385 86.5534 378.355Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M340.197 124C360.908 123.971 377.674 107.158 377.645 86.447C377.616 65.7364 360.803 48.9706 340.092 48.9997C319.382 49.0287 302.616 65.8416 302.645 86.5522C302.674 107.263 319.487 124.029 340.197 124Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M161.804 557.25C182.515 557.221 199.281 540.408 199.252 519.698C199.223 498.987 182.41 482.221 161.699 482.25C140.989 482.279 124.223 499.092 124.252 519.803C124.281 540.513 141.094 557.279 161.804 557.25Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M340.909 631.999C361.62 631.97 378.386 615.157 378.357 594.447C378.328 573.736 361.515 556.97 340.804 556.999C320.094 557.028 303.328 573.841 303.357 594.552C303.386 615.262 320.199 632.028 340.909 631.999Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M519.804 556.748C540.515 556.719 557.281 539.906 557.252 519.196C557.223 498.485 540.41 481.719 519.699 481.748C498.989 481.777 482.223 498.59 482.252 519.301C482.281 540.011 499.094 556.777 519.804 556.748Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M594.553 377.643C615.264 377.614 632.029 360.801 632 340.091C631.971 319.38 615.158 302.614 594.448 302.643C573.737 302.672 556.971 319.485 557 340.196C557.029 360.906 573.842 377.672 594.553 377.643Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M519.302 198.748C540.013 198.719 556.779 181.907 556.75 161.196C556.721 140.485 539.908 123.72 519.197 123.749C498.487 123.778 481.721 140.59 481.75 161.301C481.779 182.012 498.592 198.778 519.302 198.748Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M510.761 169.761L169.762 170.239L170.24 511.238L511.24 510.76L510.761 169.761Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M582.797 340.135L340.161 98.1788L98.2052 340.814L340.841 582.77L582.797 340.135Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M526.739 153.738L510.739 153.76L510.762 169.76L526.762 169.738L526.739 153.738Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M169.739 154.239L153.739 154.261L153.762 170.261L169.762 170.239L169.739 154.239Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M86.5659 329.248L74.9775 340.869L86.5984 352.457L98.1868 340.836L86.5659 329.248Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M170.24 511.238L154.24 511.261L154.262 527.261L170.262 527.238L170.24 511.238Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M340.833 582.809L329.245 594.43L340.866 606.018L352.454 594.397L340.833 582.809Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M340.122 75.1345L328.533 86.7554L340.154 98.3437L351.742 86.7228L340.122 75.1345Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M527.24 510.738L511.24 510.76L511.262 526.76L527.262 526.738L527.24 510.738Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M606.019 340.12L594.398 328.531L582.81 340.152L594.431 351.741L606.019 340.12Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
        </g>
        <path
          d="M340.856 593.999C480.86 593.803 594.197 480.148 594 340.144C593.804 200.14 480.149 86.8033 340.145 86.9997C200.141 87.196 86.8046 200.851 87.001 340.855C87.1973 480.859 200.852 594.195 340.856 593.999Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M161.302 199.25C182.013 199.221 198.779 182.409 198.75 161.698C198.721 140.987 181.908 124.221 161.197 124.251C140.487 124.28 123.721 141.092 123.75 161.803C123.779 182.514 140.592 199.279 161.302 199.25Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M86.5534 378.355C107.264 378.326 124.03 361.514 124.001 340.803C123.972 320.092 107.159 303.327 86.4482 303.356C65.7375 303.385 48.9718 320.197 49.0008 340.908C49.0299 361.619 65.8427 378.385 86.5534 378.355Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M340.197 124C360.908 123.971 377.674 107.158 377.645 86.447C377.616 65.7364 360.803 48.9706 340.092 48.9997C319.382 49.0287 302.616 65.8416 302.645 86.5522C302.674 107.263 319.487 124.029 340.197 124Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M161.804 557.25C182.515 557.221 199.281 540.408 199.252 519.698C199.223 498.987 182.41 482.221 161.699 482.25C140.989 482.279 124.223 499.092 124.252 519.803C124.281 540.513 141.094 557.279 161.804 557.25Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M340.909 631.999C361.62 631.97 378.386 615.157 378.357 594.447C378.328 573.736 361.515 556.97 340.804 556.999C320.094 557.028 303.328 573.841 303.357 594.552C303.386 615.262 320.199 632.028 340.909 631.999Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M519.804 556.748C540.515 556.719 557.281 539.906 557.252 519.196C557.223 498.485 540.41 481.719 519.699 481.748C498.989 481.777 482.223 498.59 482.252 519.301C482.281 540.011 499.094 556.777 519.804 556.748Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M594.553 377.643C615.264 377.614 632.029 360.801 632 340.091C631.971 319.38 615.158 302.614 594.448 302.643C573.737 302.672 556.971 319.485 557 340.196C557.029 360.906 573.842 377.672 594.553 377.643Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M519.302 198.748C540.013 198.719 556.779 181.907 556.75 161.196C556.721 140.485 539.908 123.72 519.197 123.749C498.487 123.778 481.721 140.59 481.75 161.301C481.779 182.012 498.592 198.778 519.302 198.748Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M510.761 169.761L169.762 170.239L170.24 511.238L511.24 510.76L510.761 169.761Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M582.797 340.135L340.161 98.1788L98.2052 340.814L340.841 582.77L582.797 340.135Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M526.739 153.738L510.739 153.76L510.762 169.76L526.762 169.738L526.739 153.738Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M169.739 154.239L153.739 154.261L153.762 170.261L169.762 170.239L169.739 154.239Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M86.5659 329.248L74.9775 340.869L86.5984 352.457L98.1868 340.836L86.5659 329.248Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M170.24 511.238L154.24 511.261L154.262 527.261L170.262 527.238L170.24 511.238Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M340.833 582.809L329.245 594.43L340.866 606.018L352.454 594.397L340.833 582.809Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M340.122 75.1345L328.533 86.7554L340.154 98.3437L351.742 86.7228L340.122 75.1345Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M527.24 510.738L511.24 510.76L511.262 526.76L527.262 526.738L527.24 510.738Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M606.019 340.12L594.398 328.531L582.81 340.152L594.431 351.741L606.019 340.12Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_525_13657"
          x="30.501"
          y="30.4996"
          width="620"
          height="620"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="7.5" result="effect1_foregroundBlur_525_13657" />
        </filter>
      </defs>
    </svg>
  )
}
